
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import ExchangeTabsComp from './views/Tabs/index.vue'
import ExchangeProductComp from './views/ExchangeProduct/index.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import lodash from 'lodash'
import { EnumMyAccountPacksFilter } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    ExchangeTabsComp,
    InfiniteLoading,
    ExchangeProductComp
  }
})
export default class ExchangeList extends Vue {
  tabActiveKey: number = +lodash.get(this.$route.query, 'active', EnumMyAccountPacksFilter.All.toString())

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$myV2.Account.Exchange
  }

  get pagePagination() {
    return this.PageStore.ticketPagePagination
  }

  get body() {
    return {
      productType: `${this.tabActiveKey}00`
    }
  }

  onTabChange(active: number) {
    if (this.tabActiveKey === active) return

    this.pagePagination.clearData()
    this.tabActiveKey = active

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
